import SVGIcon from "@assets/svg";
import { largeSize, tabletSize } from "@src/utils/screensize-helper";
import React from "react";
import { Text, View } from "react-native";
import useStyles from "./styles.css";
import UnawaProduct from "./unawaProduct";

type LogoProps = {
  logoColor?: string;
  termsColor?: string;
  termsStyle?: any;
}

const Logo = (props: LogoProps) => {
  const styles = useStyles();
  const isTablet = tabletSize();
  const isLargeSize = largeSize();

  const size = React.useMemo(() => {
    if(isLargeSize){
      return {
        width: 320,
        height: 60,
      };
    } 
    if (isTablet){
      return {
        width: 242,
        height: 40,
      };
    }

    return {
      width: 385,
      height: 78,
    };
  },[isLargeSize]);

  return (
    <View style={styles.v_logo_container}>
      <SVGIcon name="SignsecureLogoDrawer" {...size} fill={props.logoColor}  />
      <Text style={[styles.t_logo, { color: props.logoColor}]}>The best way to {"\n"}sign online</Text>
      <UnawaProduct />
    </View>
  );
};

export default Logo;
